module.exports = __webpack_public_path__ + "img/tc8sw.e2890833.png";